import React, { useState, useEffect, useRef, useCallback } from "react";
import { all_category_type } from "../../utils/constants";
import ResourceBody from "../../components/pages/Resource/ResourceBody";
import ResourceHeader from "../../components/pages/Resource/ResourceHeader";
import { setCategoryListByModule } from "../../store/slices/globalSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveResourcesTab,
  setAllResourcePagination,
  setIsResourcesLoading,
  setResources,
} from "../../store/slices/resourcesSlice";

const VALID_TABS = ["folders", "resources"];

const ResourcesPage = () => {
  const dispatch = useDispatch();
  const selectedTab = useSelector((state) => state.resources.activeTab);
  const { allResourcePagination, resourceFolders } = useSelector(
    (state) => state.resources,
  );
  const [activeTab, setActiveTab] = useState(
    VALID_TABS.includes(selectedTab) ? selectedTab : "folders",
  );
  const [selectedCategory, setSelectedCategory] = useState("");
  // Keeps category in sync for fetches that fire before React state updates
  const categoryOverrideRef = useRef(undefined);

  dispatch(setActiveResourcesTab(activeTab));

  const foldersResourceTotal = (resourceFolders?.data || []).reduce(
    (sum, folder) => sum + (folder.resources_count || 0),
    0,
  );

  const prepareResourcesFetch = useCallback(
    (optimisticTotal = 0, categoryOverride) => {
      if (categoryOverride !== undefined) {
        categoryOverrideRef.current = categoryOverride;
      }
      dispatch(setIsResourcesLoading(true));
      dispatch(
        setResources({
          data: [],
          meta: { total: optimisticTotal },
        }),
      );
      if (allResourcePagination.page !== 1) {
        dispatch(
          setAllResourcePagination({
            perPage: 12,
            page: 1,
          }),
        );
      }
    },
    [allResourcePagination.page, dispatch],
  );

  const handleSelectCategory = useCallback(
    (categoryId) => {
      const folder = resourceFolders?.data?.find(
        (item) => item.id == categoryId,
      );
      prepareResourcesFetch(
        categoryId ? folder?.resources_count || 0 : foldersResourceTotal,
        categoryId || "",
      );
      setSelectedCategory(categoryId || "");
      if (categoryId) {
        setActiveTab("resources");
      }
    },
    [foldersResourceTotal, prepareResourcesFetch, resourceFolders?.data],
  );

  const handleOpenFolder = useCallback(
    (folder) => {
      prepareResourcesFetch(folder?.resources_count || 0, folder?.id || "");
      setSelectedCategory(folder?.id || "");
      setActiveTab("resources");
    },
    [prepareResourcesFetch],
  );

  const handleTabChange = useCallback(
    (tabName) => {
      // Only reset when leaving a folder drill-in; avoid clearing an
      // already-valid list when the category isn't changing.
      if (tabName == "folders" && selectedCategory) {
        prepareResourcesFetch(foldersResourceTotal, "");
        setSelectedCategory("");
      }
      setActiveTab(tabName);
    },
    [foldersResourceTotal, prepareResourcesFetch, selectedCategory],
  );

  useEffect(() => {
    dispatch(setCategoryListByModule(all_category_type?.RFQ));
  }, []);

  return (
    <>
      <div className="innerContainer">
        <ResourceHeader
          activeTab={activeTab}
          setActiveTab={handleTabChange}
          selectedCategory={selectedCategory}
          setSelectedCategory={handleSelectCategory}
        />
        <ResourceBody
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          seletedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          onOpenFolder={handleOpenFolder}
          categoryOverrideRef={categoryOverrideRef}
        />
      </div>
    </>
  );
};

export default ResourcesPage;
